import * as Yup from 'yup'

import { PasswordValidador } from '../../../utils'

export default Yup.object().shape({
    password: Yup.string().required('Senha é obrigatório!')
        .test({
            name: 'Senha',
            skipAbsent: true,
            test(password, ctx) {
                let errorList = PasswordValidador.validateDynamic(password)
                if (errorList.length > 0) {
                    const resultString = errorList.join('\n')
                    return ctx.createError({ message: resultString })
                }
        
                return true
            }
        }),
    confirmPassword: Yup.string().required('Confirmar Senha é obrigatório!')
        .oneOf([Yup.ref('password'), null], 'As senhas não conferem!')
})